"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DISCLAIMER_CATEGORY_KEY = 'overview';
exports.DISCLAIMER_COMPONENT_KEY = 'disclaimer';